import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import TextareaField from '../../elements/form/TextareaField'
import { useDispatch } from 'react-redux'
import { authHeader } from '../../../utils'
import { ERROR } from '../../../store/types'
import axios from 'axios'

const ApproveExeat = ({exeat, close, reload}) => {
  const dispatch = useDispatch()
  const [remarks, setRemarks] = useState('')

  const [processing, setProcessing] = useState(false)

  const approveExeat = async () => {
    try {
      const headers = authHeader()

      const payload = {
        remarks
      }
      setProcessing(true)
      await axios.post(`${process.env.REACT_APP_BASE_URL}/exeats/approve/${exeat._id}`, payload, { headers })
      setProcessing(false)
      reload()
      close()
    } catch (error) {
      console.error('error declining exeat: ', error)
      dispatch({
        type: ERROR,
        error
      });
    }
  }

  return (
    <div className='w-full'>
      <p className='text-sm text-gray-600'>This exeat will be approved and the the person designated for pickup will receive an email and/or SMS with a pickup code to provide to college security when they arrive.</p>

      <div className='my-2 w-full'>
        <TextareaField
          inputLabel="Approval Remarks" 
          fieldId="note" 
          inputType="text" 
          requiredField={false}
          inputPlaceholder="Add a note"
          preloadValue={remarks}
        //   hasError={validationErrors.remarks} 
          returnFieldValue={(value)=>{setRemarks(value)}}
        />
      </div>

      <div className="mt-8 flex flex-row-reverse gap-x-4">
        <ModalActionButton
          buttonLabel={`Approve Exeat`}
          buttonAction={()=>{approveExeat()}}
          processing={processing}
        />

        <button
          type="button"
          className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
          onClick={()=>{close()}}
        >
          Close
        </button>
          
      </div>
    </div>
  )

}

export default ApproveExeat